export default __webpack_public_path__ + "static/media/bottom_ui_panel_star1.2aa57367.png";